// extracted by mini-css-extract-plugin
export default {"container":"notificationbanner_container__so33D","wrapper":"notificationbanner_wrapper__sYOM6","Image":"notificationbanner_Image__n6NNM","text":"notificationbanner_text__fEfIw"};